import { merge } from "lodash";
import { RouteConfig } from "vue-router";

export const enrichRouteMeta = (route: RouteConfig, meta: Record<string, any>) => merge(route, { meta });
